import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				title: "道藏 中华道藏 道家经典 在线阅读 下载 -道人家",
			}
		},
		{
			path: '/about',
			name: 'about',
			component: () => import( /* webpackChunkName: "about" */ '../views/about.vue'),
			meta: {
				title: "道人家",
			}
		},
		{
			path: '/search',
			name: 'search',
			component: () => import( /* webpackChunkName: "about" */ '../views/Search.vue'),
			meta: {
				title: "搜索-道人家",
			}
		},
		{
			path: '/c:id',
			name: 'cate',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import( /* webpackChunkName: "about" */ '../views/Cate.vue')
		},
		{
			path: '/daozang:nid-:id',
			name: 'content',
			component: () => import( /* webpackChunkName: "about" */ '../views/content.vue')
		},
		{
			path: '/daoz:nid-:tid-:id',
			name: 'scontent',
			component: () => import( /* webpackChunkName: "about" */ '../views/scontent.vue')
		},
		{
			path: '/about',
			name: 'about',
			component: () => import( /* webpackChunkName: "about" */ '../views/about.vue'),
			meta: {
				title: "道人家",
			}
		},
		{
			path: '/yjd',
			name: 'yjd',
			component: () => import( /* webpackChunkName: "about" */ '../views/yjd.vue')
		},
		{
			path: '/mulu',
			name: 'mulu',
			component: () => import( /* webpackChunkName: "about" */ '../views/mulu.vue'),
			meta: {
				title: "中华道藏目录索引",
			}
		},
		{
			path: '/dztu-:id',
			name: 'dztu',
			component: () => import( /* webpackChunkName: "about" */ '../views/dztu.vue')
		},
]
 

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})


export default router

